// NODE_MODULE
import { Moment } from 'moment';

// TEMPLATE
import T_modal from '../../../tpl/modals/editPage/additionalInformation.html';

// LIBS
import Modal from '@libs/EditPageModal';

// CUSTOM_ELEMENT
import CE_Address from '@libs/customElement/Address';
import CE_Select2 from '@libs/customElement/Select2';

// SERVICE
import S_P_Address from '@services/Provider/ProviderAddressService';
import S_Provider from '@services/Provider/ProviderService';

type AdditionalInformationData = {
	infos: {
		provider: string,
		date: Moment,
		datePayment: Moment,
		receiveDate: Moment,
		comment: string
	},
	address: {
		id: string,
		text: string
	}
	disputes: {
		enabled: boolean
		comment: string
	},
	relaunch: {
		date: Moment
	}
};

class AdditionalInformation extends Modal<AdditionalInformationData> {
	constructor(data: AdditionalInformationData) {
		super(data, T_modal);
	}

	protected preInit() {
		const N_provider = this.element.querySelector('[name="infos.provider"]') as CE_Select2;
		const N_address = this.element.querySelector('[name-select="address.id"]') as CE_Address;

		const N_datePayment = this.element.querySelector('[name="infos.datePayment"]') as HTMLInputElement;

		N_datePayment.addEventListener('change', () => {
			const date = (this.form?.getDataByName('infos.datePayment') as Moment).clone();
			this.form?.setDataByName('relaunch.date', date.subtract(3, 'days'));
		});

		N_provider.create(this.element, { disabled: true });

		N_address.setRef({ id_provider: N_provider.selectElement! });
		N_address.create(this.element);

		this.selectPostinit['infos.provider'] = N_provider;
		this.selectPostinit['address.id'] = N_address;
	}

	protected async setData(data: AdditionalInformationData) {
		const res: { [key: string]: any } = {
			infos: {
				provider: await S_Provider.getInstance().getDataToSelect2ByID(data.infos.provider),
				date: data.infos.date,
				datePayment: data.infos.datePayment,
				receiveDate: data.infos.receiveDate,
				comment: data.infos.comment
			},
			address: {
				id: await S_P_Address.getInstance().getDataToSelect2ByID(data.address.id),
				text: data.address.text
			},
			disputes: {
				enabled: data.disputes.enabled,
				comment: data.disputes.comment
			},
			relaunch: {
				date: data.relaunch.date
			}
		};

		this.form?.setData(res);
	}

	protected async getDataForm(data: { [key: string]: any }) {
		data.infos.provider = await S_Provider.getInstance().getDataToSelect2ByID(data.infos.provider);
		data.address.id = await S_P_Address.getInstance().getDataToSelect2ByID(data.address.id);

		return data;
	}
}

export default AdditionalInformation;
